import type { MenuItem } from '@wegic/ui';
import { IconArrowUpRight } from '@wegic/icon';

interface LinkMenuItemOptions {
  key: string;
  text: string;
  Icon: React.ComponentType;
  link: string;
  className?: string;
  suffixClassName?: string;
}

export function createLinkMenuItem(options: LinkMenuItemOptions): MenuItem {
  const { key, text, Icon, link, className, suffixClassName } = options;
  return {
    type: 'item',
    key,
    text,
    className,
    icon: <Icon />,
    suffix: <IconArrowUpRight className={suffixClassName} />,
    onClick: () => window.open(link, '_blank', 'noopener,noreferrer'),
  };
}

export function createDividerMenuItem(key = 'divider'): MenuItem {
  return { key, type: 'divider' };
}
